import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import ApiService from "../../helpers/Services.js";
import CardSkeleton from "../../components/skeleton/CardSkeleton.js";
import "./role.scss";

function Role() {
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch roles from API
  const fetchRoles = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await ApiService.post("user-management", {
        action: "listRoles",
        payload: { vendor: "AARP" },
      });
      setRoles(data);
    } catch (err) {
      setError("Failed to load roles. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <section className="role">
      <h1 className="role-title">User Roles</h1>

      {error && <p className="role-error">{error}</p>}

      <div className="role-container">
        {isLoading ? (
          // Render skeleton loaders while loading
          <>
            <CardSkeleton />
            <CardSkeleton />
            <CardSkeleton />
          </>
        ) : roles.length > 0 ? (
          // Render roles dynamically if available
          roles.map(({ rolename }) => (
            <Link
              key={rolename}
              to={`/admin/roles/${encodeURIComponent(rolename)}`}
              className={`role-card ${rolename}`}
            >
              <div className="role-card-content">
                <p className="role-card-name">{rolename}</p>
              </div>
            </Link>
          ))
        ) : (
          // Fallback for empty state
          <p className="role-empty">No roles available at the moment.</p>
        )}
      </div>
    </section>
  );
}

export default Role;